import { Form, InputNumber, Button, message, Modal } from "antd";
import { useEffect } from "react";
import axios from "axios";

export default function Nom007DPEAInteriorForm(props) {
  const { visible, title, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (verification) {
      form.setFieldsValue(verification);
    }
  }, [verification, form]);

  const onFinish = (values) => {
    const verificationData = {
      ...verification,
      ...values,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, verificationData)
      .then(() => {
        message.success("Campos actualizados correctamente");
        setVerification(verificationData);
        setVisible(false);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al actualizar los campos");
      });
  };

  return (
    <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} centered>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="DPEAInteriorMin" label="DPEA Interior Mínimo">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="DPEAInteriorMax" label="DPEA Interior Máximo">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="DPEAIInteriorProm" label="DPEA Interior Promedio">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Guardar
        </Button>
      </Form>
    </Modal>
  );
}
